import AuthDialogLayout from "components/Layout/AuthDialogLayout";
import useAuth from "hooks/useAuth";
import useDialog from "hooks/useDialog";

import React, { useEffect, useState } from "react";

const ForgotPasswordDialog = () => {
  const {
    isForgotPasswordDialogOpen,
    closeForgotPasswordDialog,
    openSigninDialog,
  } = useDialog();
  const { resetPassword, loading, error } = useAuth();
  const [email, setEmail] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await resetPassword(email);
      setIsButtonDisabled(true);
      setCountdown(60);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    let timer;
    if (isButtonDisabled && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      setIsButtonDisabled(false);
    }
    return () => clearInterval(timer);
  }, [isButtonDisabled, countdown]);

  return (
    <AuthDialogLayout
      isDialogOpen={isForgotPasswordDialogOpen}
      closeDialog={closeForgotPasswordDialog}
    >
      <form onSubmit={handleSubmit} className="mt-10 lg:mt-[158px]">
        <h2 className="text-[20px] max-w-[360px] font-semibold leading-[28px] text-[#1A1A1A]">
          Inserisci la tua email per ricevere il link di recupero password
        </h2>
        <div className="mt-[24px]">
          <label className="text-[11px] font-normal text-[#333333] pl-4">
            Email
          </label>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="auth-input"
          />
        </div>
        {error && (
          <div className="mt-[24px] ">
            <p className="text-[#F61D1D] text-center text-[15px] font-normal line-clamp-2">
              {error}
            </p>
          </div>
        )}
        <button
          type="submit"
          disabled={loading || isButtonDisabled}
          className="auth-btn"
        >
          {isButtonDisabled
            ? `Mail Inviata (${countdown}s)`
            : "Invia Link per Recupero Password"}
        </button>
        <hr className="bg-[#E5E5E5] h-[0.5px] w-full" />

        <div className="mt-[24px] flex items-center space-x-2 justify-center">
          <p className="text-[12px] font-normal leading-5 tracking-[0.3px] text-[#1A1A1A]">
            Ti ricordi la password?{" "}
          </p>
          <p
            onClick={() => {
              closeForgotPasswordDialog();
              openSigninDialog();
            }}
            className="cursor-pointer text-[12px] font-normal leading-5 tracking-[0.3px] text-primary"
          >
            Accedi{" "}
          </p>
        </div>
      </form>
    </AuthDialogLayout>
  );
};

export default ForgotPasswordDialog;
